module.exports = "/_next/static/images/3153eb59e950dfa954afc12d7bb9c711-instagram-icon.svg";